import React, { useState } from "react"
import { useSelector } from "react-redux"
import {
	Button,
	Card,
	CardHeader,
	Table,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
} from "reactstrap"
import { postEndGame, postResult } from "../../api"
import { endGame } from "../../api/socket/functions"
import { getSportsConfig } from "../../utility/constants/sportConfig"

const SetsTable = ({
	setsDone,
	setLoading,
	onLeave,
	setsName = "Set",
	outlineDone = false,
	onButtonClick,
	calculate,
	sets = getSportsConfig(localStorage.getItem("sport")).sets,
	bodyToPost,
	onlyEnd,
}) => {
	const [isOpen, setIsOpen] = useState(false)
	const rerender = useSelector((state) => state.rerender.num)
	const spectate = localStorage.getItem("spectate")
	const penaltiesIsDone = useSelector(
		(state) =>
			state.penaltiesOrEnd == "done" || state.penaltiesOrEnd == "forfeit"
	)

	const homeTeam = JSON.parse(localStorage.getItem("homeTeam") ?? "{}")
	const awayTeam = JSON.parse(localStorage.getItem("awayTeam") ?? "{}")
	const columns = []
	const calculation = { homeTeam: 0, awayTeam: 0 }
	if (calculate) {
		for (let i = 0; i < setsDone.homeTeam.length; i++) {
			if (setsDone.homeTeam[i] > setsDone.awayTeam[i]) {
				calculation.homeTeam += 1
			} else if (setsDone.homeTeam[i] < setsDone.awayTeam[i]) {
				calculation.awayTeam += 1
			} else if (setsDone.homeTeam[i]?.tieBreak) {
				if (setsDone.homeTeam[i].tieBreak > setsDone.awayTeam[i].tieBreak) {
					calculation.homeTeam += 1
				} else {
					calculation.awayTeam += 1
				}
			}
		}
	}

	for (let x = 1; x <= sets; x++) {
		columns.push(
			<th key={`setHeader-${x}-${setsName}`}>
				{x}. {setsName}
			</th>
		)
	}
	for (let x = sets + 1; x <= setsDone.homeTeam.length; x++) {
		columns.push(
			<th key={`setHeader-${x}-${setsName}`}>
				Ekstra {x}. {setsName}
			</th>
		)
	}

	const createRow = (player, key) => {
		const columns = []
		for (let x = 0; x < setsDone.homeTeam.length; x++) {
			if (setsDone[key][x]?.tieBreak > -1) {
				columns.push(
					<td key={`set-${player.name}-${setsName}-${x}-${rerender}`}>
						{setsDone[key][x].realResult}({setsDone[key][x].tieBreak})
					</td>
				)
			} else {
				columns.push(
					<td key={`set-${player.name}-${setsName}-${x}-${rerender}`}>
						{setsDone[key][x]}
					</td>
				)
			}
		}

		for (let x = setsDone.homeTeam.length; x < sets; x++) {
			columns.push(<td key={`set-${player.name}-${setsName}-${x}`}></td>)
		}

		return (
			<tr>
				<td>
					{player.name} {player.surname ?? ""}
				</td>
				{calculate && (
					<td>
						<b>{calculation[key]}</b>
					</td>
				)}
				{columns}
			</tr>
		)
	}

	const onDone = () => {
		setIsOpen(false)
		setLoading(true)
		const game = JSON.parse(localStorage.getItem("gameDetails") ?? "{}").gameId
		const sport = localStorage.getItem("sport")

		if (onlyEnd) {
			endGame()
			setLoading(false)
			return
		}

		let winnerId

		const score = { homeScore: 0, awayScore: 0 }
		if (!bodyToPost) {
			let sets = { homeScore: [], awayScore: [] }
			for (let x = 0; x < setsDone?.homeTeam.length; x++) {
				sets.homeScore.push(setsDone.homeTeam[x])
				sets.awayScore.push(setsDone.awayTeam[x])
				if (setsDone.homeTeam[x] > setsDone.awayTeam[x]) {
					score.homeScore++
				} else if (setsDone.homeTeam[x] < setsDone.awayTeam[x]) {
					score.awayScore++
				}
			}

			bodyToPost = { sets }
		} else {
			// if it entered here, its because this is from tennis
			bodyToPost.forEach((element) => {
				score[element.winner == "homeTeam" ? "homeScore" : "awayScore"]++
			})
		}

		if (score.homeScore > score.awayScore) {
			winnerId = homeTeam.id || homeTeam._id || homeTeam.playerId
		} else if (score.homeScore < score.awayScore) {
			winnerId = awayTeam.id || awayTeam._id || awayTeam.playerId
		}

		postResult({
			sport,
			game,
			result: bodyToPost,
			winner: winnerId,
		}).then(({ error, offline }) => {
			if (!error && !offline)
				postEndGame({ game, sport }).then(({ error, offline }) => {
					setLoading(false)
					if (!error && !offline) {
						if (onLeave) onLeave(true)
					}
				})
			else setLoading(false)
		})
		setLoading(true)
	}

	const getSetsScore = () => {
		const { homeTeam: homeTeamSets, awayTeam: awayTeamSets } = setsDone
		const score = { homeTeam: 0, awayTeam: 0 }

		for (let x = 0; x < setsDone.homeTeam.length; x++) {
			if (homeTeamSets[x] > awayTeamSets[x]) {
				score.homeTeam++
			} else if (homeTeamSets[x] < awayTeamSets[x]) {
				score.awayTeam++
			} else if (homeTeamSets[x]?.tieBreak > -1) {
				if (homeTeamSets[x].tieBreak > awayTeamSets[x].tieBreak) {
					score.homeTeam++
				} else {
					score.awayTeam++
				}
			}
		}

		if (score.homeTeam > score.awayTeam) {
			return (
				<>
					<h3>
						Pobjednik: {homeTeam.name} {homeTeam.surname ?? ""}
					</h3>
					<h5>
						Rezultat setova: {score.homeTeam} - {score.awayTeam}
					</h5>
				</>
			)
		} else if (score.homeTeam < score.awayTeam) {
			return (
				<>
					<h3>
						Pobjednik: {awayTeam.name} {awayTeam.surname ?? ""}
					</h3>
					<h5>
						Rezultat setova: {score.homeTeam} - {score.awayTeam}
					</h5>
				</>
			)
		} else {
			return (
				<>
					<h3>Izjednačeno</h3>
					<h5>
						Rezultat setova: {score.homeTeam} - {score.awayTeam}
					</h5>
				</>
			)
		}
	}

	return (
		<Card key={`sets-table-${rerender}`}>
			<CardHeader>
				<h1 style={{ marginBottom: -4 }}>Setovi</h1>
				{!spectate && !penaltiesIsDone && (
					<Button.Ripple
						color={
							(
								calculate
									? calculation.homeTeam == calculation.awayTeam
									: false
							)
								? "secondary"
								: "primary"
						}
						onClick={() => {
							if (onButtonClick) {
								onButtonClick()
							} else {
								setIsOpen(true)
							}
						}}
						outline={
							calculate
								? calculation.homeTeam == calculation.awayTeam
								: outlineDone || setsDone.homeTeam.length < sets / 2
						}
						disabled={
							calculate
								? calculation.homeTeam == calculation.awayTeam
								: false
						}
					>
						Završi utakmicu
					</Button.Ripple>
				)}
			</CardHeader>
			<div>
				<Table responsive>
					<thead>
						<tr>
							<th>Ime</th>
							{calculate && <th>Ukupno</th>}
							{columns}
						</tr>
					</thead>
					<tbody>
						{createRow(homeTeam, "homeTeam")}
						{createRow(awayTeam, "awayTeam")}
					</tbody>
				</Table>
			</div>

			<Modal
				isOpen={isOpen}
				toggle={() => setIsOpen(false)}
				className="modal-dialog-centered"
			>
				<ModalHeader toggle={() => setIsOpen(false)}>
					Jesi li siguran?
				</ModalHeader>
				<ModalBody>
					{getSetsScore()}
					<br />

					<span>
						Jel to točno?{" "}
						<span style={{ color: "red" }}>
							Ovo se nemože poništiti.
						</span>
					</span>
				</ModalBody>
				<ModalFooter>
					<Button.Ripple color="primary" outline onClick={onDone}>
						Završi utakmicu
					</Button.Ripple>
					<Button.Ripple
						color="secondary"
						onClick={() => setIsOpen(false)}
					>
						Odustani
					</Button.Ripple>
				</ModalFooter>
			</Modal>
		</Card>
	)
}

export default SetsTable
